




















































































































import {Component, Prop, Mixins} from 'vue-property-decorator'
import {IResource} from 'simpli-web-sdk'
import {MixinMember} from '@/components/mixins/MixinMember'
import DeliveryRequestCheckList from '@/model/request/DeliveryChecklistRequest'
import {getResponsavel, ItrackCollection} from '@/helpers'
import Motorista from '@/model/resource/Motorista'
import ItDateInput from '@/components/itrack/ItDateInput.vue'

@Component({
    components: {ItDateInput},
})
export default class FilterDeliveryChecklist extends Mixins(MixinMember) {
    @Prop({required: true}) value!: DeliveryRequestCheckList
    @Prop({type: Array, default: () => []}) hidden!: string[]
    @Prop({type: Array, default: () => []}) shown!: string[]
    @Prop({type: Array, default: () => []}) blocked!: string[]

    allMotorista = ItrackCollection.allMotorista

    get motoristaResource() {
        return this.allMotorista.get(this.value.idMotorista)
    }

    set motoristaResource(val: Motorista | null) {
        this.value.idMotorista = val && val.$id || null
    }

    allDocsEvent(item: IResource, cache: IResource[]) {
        this.value.populateAllDocs(cache)
    }

    async mounted() {
        await this.allMotorista.query()
    }

    cleanDocs() {
        this.value.cleanDocs()
    }

    cleanCtes() {
        this.value.cleanCtes()
    }
}
